<script setup lang="ts">
  import type { PropType } from 'vue'

  import { HLTooltip } from '@platform-ui/highrise'

  const props = defineProps({
    id: {
      type: String,
      required: false,
      default: undefined,
    },
    placement: {
      type: String as PropType<
        | 'top'
        | 'top-start'
        | 'top-end'
        | 'bottom'
        | 'bottom-start'
        | 'bottom-end'
        | 'left'
        | 'left-start'
        | 'left-end'
        | 'right'
        | 'right-start'
        | 'right-end'
      >,
      required: false,
      default: 'bottom',
    },
    variant: {
      type: String as PropType<'light' | 'dark'>,
      required: false,
      default: 'dark',
    },
    trigger: {
      type: String as PropType<'hover' | 'click' | 'focus' | 'manual'>,
      required: false,
      default: 'hover',
    },
    show: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    to: {
      type: [String, Object, Boolean] as PropType<string | HTMLElement | false>,
      required: false,
      default: undefined,
    },
  })

  defineOptions({ name: 'CPTooltip', inheritAttrs: false })
</script>

<template>
  <HLTooltip
    v-bind="$attrs"
    :id="props.id"
    :placement="props.placement"
    :variant="props.variant"
    :trigger="props.trigger"
    :show="props.show"
    :disabled="props.disabled"
    :to="props.to"
  >
    <template v-if="$slots.trigger" #trigger>
      <slot name="trigger" />
    </template>
    <slot />
  </HLTooltip>
</template>

<style scoped></style>
